import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Map, Marker, Circle, GoogleApiWrapper } from "google-maps-react";
import { useSelector } from "react-redux";

const MultipleAudienceRadiusMap = ({ center, marker, circle, radius, showMarker, google }) => {
    const US = { lat: 39.470125122, lng: -98.0859375 };
    const UK = { lat: 55.378052, lng: -3.435973 };

    const environment = useSelector(state => state.session.environment);

    const [mapCenter, setMapCenter] = useState(environment == "ukprod" ? UK : US);
    const [circleCenter, setCircleCenter] = useState(environment == "ukprod" ? UK : US);

    useEffect(() => {
        if (center && center[0] && center[1]) {
            setMapCenter({ lat: center[0], lng: center[1] });
        }
    }, [center]);

    useEffect(() => {
        if (circle && circle[0] && circle[1]) {
            setCircleCenter({ lat: circle[0], lng: circle[1] });
        }
    }, [circle]);

    return (
        <Map
            containerStyle={{ width: "1200px", height: "350px", position: "relative" }}
            style={{ width: "1200px", height: "350px", position: "relative" }}
            google={google}
            initialCenter={mapCenter}
            center={mapCenter}
            zoom={environment == "ukprod" ? 5 : 4}
            streetViewControl={false}
            mapTypeControl={false}
            fullscreenControl={false}
            disableDefaultUI={true}
            scrollwheel={false}
            navigationControl={false}
            scaleControl={false}
            draggable={false}
        >
            {showMarker && (
                <Circle
                    radius={radius}
                    center={circleCenter}
                    strokeColor="transparent"
                    strokeOpacity={0.8}
                    strokeWeight={2}
                    fillColor="#0075BC"
                    fillOpacity={0.3}
                />
            )}
            {marker &&
                marker.map(({ id, name, position }) => <Marker key={id} position={position} name={name}></Marker>)}
        </Map>
    );
};

MultipleAudienceRadiusMap.propTypes = {
    center: PropTypes.array,
    marker: PropTypes.array,
    circle: PropTypes.array,
    radius: PropTypes.number,
    zoom: PropTypes.number,
    location: PropTypes.string,
    showMarker: PropTypes.bool,
    google: PropTypes.any,
};

export default GoogleApiWrapper({
    apiKey: "AIzaSyAJny9h66DpQl3l_s0ISmsmAEDbY1c7uEc",
})(MultipleAudienceRadiusMap);
